import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueEasyLightbox from "vue-easy-lightbox";
import VCalendar from "v-calendar";
import "v-calendar/style.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

import VueGtag from "vue-gtag";
import createGtm from "@gtm-support/vue-gtm";

// importing the helper
import interceptorsSetup from "@/shared/helpers/interceptors";
// and running it somewhere here
interceptorsSetup();

const app = createApp(App);

app.use(router);

app.use(VueEasyLightbox);
app.use(VCalendar, {});
app.use(VueSweetalert2);
app.use(VueTelInput);

app.use(
  VueGtag,
  {
    //config: { id: "UA-1234567-1" }
    config: {
      id: "UA-70816763-1",
      send_page_view: false,
    },
  },
  router
);

app.use(createGtm, {
  id: "GTM-KVFXKGX", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  //id: 'GTM-TFRKS5H', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: false, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: null, // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

app.mount("#app");
